import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { LocalStorageProvider } from "../../../services/storage/storage.service";
import { AuthService } from "../../../services/authguard/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private storageService: LocalStorageProvider
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let token = localStorage.getItem("stoken");
    let cUser = localStorage.getItem("CurrentUser");
    let guestUser = localStorage.getItem("guestUser");
    let UserId = localStorage.getItem("UserId");
    let loggedIn = localStorage.getItem("isLoggedIn");
    if (!token ) {
      return true;
    } else if (!loggedIn && !token) {
      return true;
    } else if (!UserId && token) {
      return true;
    } else {
      this.router.navigate([""]);
      return false;
    }
  }
}
